








































































































import { computed, defineComponent, PropType, ref, watch } from '@nuxtjs/composition-api';
import AppContentCardThumbnail from '~/components/partials/App/AppContentCardThumbnail.vue';
import AppContentFavoriteIconButton from '~/components/partials/App/AppContentFavoriteIconButton.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import ProducingAreaFlag from '~/components/partials/ProducingArea/ProducingAreaFlag.vue';
import ProductLabel from '~/components/partials/Product/ProductLabel.vue';
import { useListFavorite } from '~/composables/contents/useListFavorite';
import { useWOVNio } from '~/composables/wovn/useWOVNio';
import { TOAST_TIME_OUT } from '~/constants';
import { BOTTLE_100, BOTTLE_200, THUMBNAIL_300, THUMBNAIL_250 } from '~/constants/profilesForImage';
import { isInsidePeriod, url } from '~/utils';
import { sendGaEvent as sendEvent, GaTopPartsType } from '~/utils/ga';
import { CommonProducingArea } from '~/types/common';
import { ProducerCard } from '~/types/modules/contents';
import { DisplayLang, FavoriteTypes } from '~/enums';

export default defineComponent({
  components: {
    AppLink,
    AppImage,
    AppContentCardThumbnail,
    ProducingAreaFlag,
    ProductLabel,
    AppContentFavoriteIconButton,
  },
  props: {
    item: {
      type: Object as PropType<ProducerCard>,
      required: true,
    },
    unresponsive: {
      type: Boolean,
      default: false,
    },
    isTop: {
      type: Boolean,
      default: false,
    },
    gaPartsType: {
      type: String as PropType<GaTopPartsType>,
      default: null,
    },
    // 関連する生産者
    isRelatedContents: {
      type: Boolean,
      default: false,
    },
    isFavButtonHidden: {
      type: Boolean,
      default: false,
    },
    // マイワイン/お気に入り生産者
    isFavoriteProducers: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const detailUrl = computed(() => url('PRODUCER_DETAIL', { id: props.item.permalink }));
    const { currentLang } = useWOVNio();
    const { checkIsFavorite } = useListFavorite();
    const isFavorite = computed(() => checkIsFavorite(props.item.permalink, FavoriteTypes.PRODUCER));

    const thumbnailSpImage = computed(() =>
      props.item.thumbnailSpImage ? props.item.thumbnailSpImage + THUMBNAIL_250 : undefined
    );
    const mainSpImage = computed(() => (props.item.mainSpImage ? props.item.mainSpImage + THUMBNAIL_250 : undefined));
    const thumbnailPcImage = computed(() =>
      props.item.thumbnailPcImage ? props.item.thumbnailPcImage + THUMBNAIL_300 : undefined
    );
    const mainPcImage = computed(() => (props.item.mainPcImage ? props.item.mainPcImage + THUMBNAIL_300 : undefined));

    // お気に入りボタンのトースト設定
    const showToast = ref(false);
    let toastTimeoutObj: number | null = null;

    // お気に入りのトーストの表示制御
    // NOTE: お気に入りボタンコンポーネントに共通のトースト制御ありますが、SP一覧のみデザインが違うので、<Portal to="">経由で表示します
    watch(isFavorite, () => {
      if (isFavorite.value) showToast.value = true;
    });
    watch(showToast, () => {
      if (!showToast.value) return;
      if (toastTimeoutObj != null) {
        window.clearTimeout(toastTimeoutObj);
      }
      toastTimeoutObj = window.setTimeout(() => {
        showToast.value = false;
      }, TOAST_TIME_OUT);
    });

    const producingArea = computed((): CommonProducingArea | undefined => {
      if (props.item.areas.length === 0) {
        return;
      }

      return {
        code_id: props.item.areas[0].id.toString(),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        areas: props.item.areas[0].regions.map(({ id, name }) => ({
          id: id.toString(),
          name,
        })),
      };
    });

    const isShownProducerNameJa = computed(() => currentLang.value.code === DisplayLang.JA);

    const sendGaEvent = () => {
      if (!props.gaPartsType) {
        return;
      }
      sendEvent(props.gaPartsType, detailUrl.value, props.item.name);
    };

    const isShownNewLabel = computed(() => {
      // 期間未設定の場合はラベル非表示
      return isInsidePeriod(props.item.newLabelStart, props.item.newLabelEnd, true);
    });

    const isShownNewVintageLabel = computed(() => {
      // 期間未設定の場合はラベル非表示
      return isInsidePeriod(props.item.vintageNewLabelStart, props.item.vintageNewLabelEnd, true);
    });

    return {
      thumbnailSpImage,
      thumbnailPcImage,
      mainSpImage,
      mainPcImage,
      detailUrl,
      producingArea,
      sendGaEvent,
      isShownProducerNameJa,
      isShownNewLabel,
      isShownNewVintageLabel,
      isFavorite,
      showToast,
      BOTTLE_100,
      BOTTLE_200,
    };
  },
});
